/*
* Palo Alto Theme
*
* Use this file to add custom Javascript to Palo Alto.  Keeping your custom
* Javascript in this fill will make it easier to update Palo Alto. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/

// Using GSAP
// (function() {
//   // Add custom code below this line
// gsap.registerPlugin(ScrollTrigger);


// const capsule = document.getElementById("capsuleSwap");
// const stillURL = capsule.dataset.stillImg;
// const gifURL = capsule.dataset.gifImg;

// ScrollTrigger.create({
//     trigger: ".image-text-supplements-section",
//     // start: "top bottom",  
//     // end: "bottom top",
//     start: "top bottom",  
//     end: "bottom top",
//     scrub: true,
//     // scroller: ".ms-section",
//     markers: true,    // CHECK where the trigger fires
//     onEnter: () => {
//       capsule.src = gifURL;
//       capsuleSwap.removeAttribute("srcset");
//       capsuleSwap.removeAttribute("sizes");
//     },
//     onEnterBack: () => {
//       capsule.src = gifURL;
//       capsuleSwap.removeAttribute("srcset");
//       capsuleSwap.removeAttribute("sizes");
//     },
//     onLeave: () => {
//       capsule.src = stillURL;
//     },
//     onLeaveBack: () => {
//       capsule.src = stillURL;
//     }
// });

// })();




// Using JQuery
$(function () {
if ($("#capsuleSwap").length > 0 ){
    const $img = $("#capsuleSwap"),
          still      = $img.data("still-img"),
          stillSet   = $img.data("still-srcset"),
          stillSize  = $img.data("still-sizes"),
          gif        = $img.data("gif-img"),
          gifSet     = $img.data("gif-srcset"),
          gifSize    = $img.data("gif-sizes"),
          // $section   = $(".image-text-supplements-section");
          $section   = $(".section-with-gif-swap");
          

    let active = false;

    const check = () => {
        const top = $(window).scrollTop(),
              bottom = top + $(window).height(),
              secTop = $section.offset().top,
              secBottom = secTop + $section.outerHeight(),
              visible = secBottom > top && secTop < bottom;

        if (visible && !active) {
            // GIF MODE
            $img.attr("src", gif);

            if (gifSet)  $img.attr("srcset", gifSet);
            if (gifSize) $img.attr("sizes", gifSize);
            if (!gifSet && !gifSize) {
                $img.removeAttr("srcset");
                $img.removeAttr("sizes");
            }

            active = true;
        } 
        else if (!visible && active) {

            // STILL MODE
            $img.attr("src", still);

            if (stillSet)  $img.attr("srcset", stillSet);
            if (stillSize) $img.attr("sizes", stillSize);

            active = false;
        }
    };

    $(window).on("scroll resize load", check);
    check();
  }
});





  document.addEventListener("DOMContentLoaded", () => {
    //Code added by MS Start


    // const section     = document.querySelector(".image-feature-timeline");
    // const imagesWrap  = section.querySelector(".timeline-images");
    // const images      = section.querySelectorAll(".timeline-image");
    // const items       = section.querySelectorAll(".timeline-item");

    // if (images.length !== items.length || images.length === 0) {
    //   console.warn("Images and list items count mismatch");
    //   return;
    // }

    // // ─── 1. Pin the images column while scrolling through the entire list ───
    // ScrollTrigger.create({
    //   trigger: ".timeline-grid",
    //   start: "top 100px",
    //   end: () => "+=" + ((section.querySelector(".timeline-images").offsetHeight - window.innerHeight * 0.4) + 200),
    //   pin: section,
    //   pinSpacing: true,
    //   anticipatePin: 1,
    //   markers: true
    // });

    // // ─── 2. One ScrollTrigger per <li> → changes the active image ───
    // items.forEach((item, index) => {
    //   ScrollTrigger.create({
    //     trigger: item,
    //     start: "top 35%",           
    //     end: "bottom 55%",          
    //     onEnter: () => setActiveImage(index),
    //     onEnterBack: () => setActiveImage(index),
    //   });
    // });

    // // Helper to switch active image
    // function setActiveImage(idx) {
    //   images.forEach((img, i) => {
    //     img.classList.toggle("active", i === idx);
    //   });

    //   items.forEach((item, i) => {
    //     item.classList.toggle("active", i === idx);
    //   });
    // }
    
    // setActiveImage(0);

    // ScrollTrigger.refresh();
    
    
//Code added by MS End




    let expertCards = document.querySelectorAll(`.science-experts-section .expert-cards .expert-card`);
    let expertCardsFrontImg = document.querySelectorAll(`.science-experts-section .expert-card-front .img-box`);
    let expertCardsFrontBody = document.querySelectorAll(`.science-experts-section .expert-card-front .expert-card__body`);
      let maxheight = [];
      if(expertCardsFrontImg.length){
        for(let i=0; i<expertCardsFrontImg.length; i++){
          maxheight.push(Math.ceil(expertCardsFrontImg[i]?.getBoundingClientRect().height + expertCardsFrontBody[i]?.getBoundingClientRect().height)); 
        }
        if(maxheight.length){
          let minHeight = Math.max(...maxheight);
          expertCards.forEach(card => card.style.minHeight = `${minHeight}px`);
        }
    }

    $(".read-bio-link").on("click",function(e){
    e.preventDefault();
        $(this).parents(".expert-card").addClass("open_box");
    });

    $(document).on("click",".read-bio-close",function(e){
    e.preventDefault();
        $(this).parents(".expert-card").removeClass("open_box");
    });
    
  });








//// MS
// Perfect Working 
// document.addEventListener("DOMContentLoaded", function () {

//   const section = document.querySelector(".step-products-section");

//   const steps = [
//     { el: document.querySelector(".step-line-one-horizontal"),  type: "width"  },
//     { el: document.querySelector(".step-line-vertical"),         type: "height" },
//     { el: document.querySelector(".step-line-horizontal"),       type: "width"  },
//     { el: document.querySelector(".step-line-two-vertical"),     type: "height" },
//     { el: document.querySelector(".step-line-two-horizontal"),   type: "width"  }
//   ];

//   const TRIGGER_OFFSET = 600;
//   const SMOOTHING = 0.1; // Adjust between 0.05 (slower) to 0.15 (faster)

//   let currentProgress = 0;
//   let targetProgress = 0;
//   let rafId = null;

//   function clamp(v, min, max) { return Math.min(Math.max(v, min), max); }

//   function computeProgress() {
//     const rect = section.getBoundingClientRect();
//     const winH = window.innerHeight;

//     const startPoint = winH - TRIGGER_OFFSET;
//     const scrollRange = (rect.height + TRIGGER_OFFSET) - winH;

//     if (scrollRange <= 0) return 0;

//     let raw = (startPoint - rect.top) / scrollRange;
//     return clamp(raw, 0, 1);
//   }

//   function render() {
//     // Get target progress
//     targetProgress = computeProgress();
    
//     // Smooth interpolation
//     currentProgress += (targetProgress - currentProgress) * SMOOTHING;
    
//     // Snap to target when very close (prevents infinite micro-movements)
//     if (Math.abs(targetProgress - currentProgress) < 0.001) {
//       currentProgress = targetProgress;
//     }
    
//     // Convert to percentage (0 to 100)
//     const percent = currentProgress * 100;

//     // Auto divide into equal slices
//     const totalSteps = steps.length;
//     const slice = 100 / totalSteps;

//     steps.forEach((step, index) => {
//       const start = slice * index;
//       const end   = slice * (index + 1);

//       if (percent <= start) {
//         if (step.type === "width") step.el.style.width = "0%";
//         else step.el.style.height = "0%";
//       }
//       else if (percent >= end) {
//         if (step.type === "width") step.el.style.width = "100%";
//         else step.el.style.height = "100%";
//       }
//       else {
//         let local = (percent - start) / (end - start);
//         let pct = local * 100;

//         if (step.type === "width") step.el.style.width = pct + "%";
//         else step.el.style.height = pct + "%";
//       }
//     });

//     rafId = requestAnimationFrame(render);
//   }

//   const observer = new IntersectionObserver(
//     entries => {
//       entries.forEach(entry => {
//         if (entry.isIntersecting) {
//           if (!rafId) {
//             rafId = requestAnimationFrame(render);
//           }
//         } else {
//           if (rafId) {
//             cancelAnimationFrame(rafId);
//             rafId = null;
//           }
//         }
//       });
//     },
//     { threshold: 0.01 }
//   );

//   observer.observe(section);
// });


document.addEventListener("DOMContentLoaded", function () {

  const section = document.querySelector(".step-products-section");
  // EARLY RETURN if element not found
  if (!section) return;

  function getSteps() {
    if (window.innerWidth < 768) {
      return [
        { el: document.querySelector(".step-line-one-horizontal"), type: "width" },
        { el: document.querySelector(".step-line-vertical"),       type: "height" },
        { el: document.querySelector(".step-line-two-vertical"),   type: "height" }
      ];
    }

    return [
      { el: document.querySelector(".step-line-one-horizontal"), type: "width"  },
      { el: document.querySelector(".step-line-vertical"), type: "height" },
      { el: document.querySelector(".step-line-two-vertical-right"), type: "height" },
      { el: document.querySelector(".step-line-horizontal"), type: "width"  },
      { el: document.querySelector(".step-line-two-vertical"), type: "height" },
      { el: document.querySelector(".step-line-two-horizontal"), type: "width"  }
    ];
  }

  function getOffset() {
    return window.innerWidth < 768
      ? 250   
      : 450;                        
  }

  let steps = getSteps();
  let TRIGGER_OFFSET = getOffset();

  const SMOOTHING = 0.1;

  let currentProgress = 0;
  let targetProgress = 0;
  let rafId = null;

  function clamp(v, min, max) {
    return Math.min(Math.max(v, min), max);
  }

  function computeProgress() {
    const rect = section.getBoundingClientRect();
    const winH = window.innerHeight;

    const startPoint = winH - TRIGGER_OFFSET;
    const scrollRange = (rect.height + TRIGGER_OFFSET) - winH;

    if (scrollRange <= 0) return 0;

    let raw = (startPoint - rect.top) / scrollRange;
    return clamp(raw, 0, 1);
  }

  function render() {
    targetProgress = computeProgress();

    // Smooth scroll interpolation
    currentProgress += (targetProgress - currentProgress) * SMOOTHING;

    if (Math.abs(targetProgress - currentProgress) < 0.001) {
      currentProgress = targetProgress;
    }

    const percent = currentProgress * 100;

    const totalSteps = steps.length;
    const slice = 100 / totalSteps;

    steps.forEach((step, index) => {
      const start = slice * index;
      const end   = slice * (index + 1);

      if (percent <= start) {
        step.el.style[step.type] = "0%";
      }
      else if (percent >= end) {
        step.el.style[step.type] = "100%";
      }
      else {
        let local = (percent - start) / (end - start);
        step.el.style[step.type] = (local * 100) + "%";
      }
    });

    rafId = requestAnimationFrame(render);
  }

  // Update steps + offset when resizing
  window.addEventListener("resize", () => {
    steps = getSteps();
    TRIGGER_OFFSET = getOffset();
  });

  const observer = new IntersectionObserver(
    entries => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          if (!rafId) rafId = requestAnimationFrame(render);
        } else {
          if (rafId) {
            cancelAnimationFrame(rafId);
            rafId = null;
          }
        }
      });
    },
    { threshold: 0.01 }
  );

  observer.observe(section);
});


// Set first LI active by default in both navigation blocks
$(".mobile-nav .mobile-menu__item:first").addClass("active");
$(".menu-second-part .mobile-menu__item:first").addClass("active");

$(".mobile-nav .mobile-menu__item").not(".menu-second-part .mobile-menu__item").on("click", function (e) {
    e.preventDefault();

    $(".mobile-nav .mobile-menu__item").removeClass("active");
    $(this).addClass("active");

    const selected_menu = $(this).attr("data-tab-content");

    console.log("Clicked:", selected_menu);
    
    $(".menu-second-part .mobile-menu__item").removeClass("active");

    $(`.menu-second-part .mobile-menu__item[data-tab-content='${selected_menu}']`).addClass("active");
});



// custom subscription widget

// (function () {
//   const WIDGET_TAG = 'recharge-subscription-widget';

//   function shadowQueryAll(root, selector) {
//     const results = [];
//     (function walk(r) {
//       r.querySelectorAll(selector).forEach(el => results.push(el));
//       r.querySelectorAll('*').forEach(el => { if (el.shadowRoot) walk(el.shadowRoot); });
//     })(root);
//     return results;
//   }

//   function getBenefitsHTML(shadow) {
//     const el = shadowQueryAll(shadow, 'rc-benefits')[0];
//     const list = el?.shadowRoot?.querySelector('.rc-benefits__list');
//     return list ? list.innerHTML : '';
//   }

//   function cleanText(el) {
//     if (!el) return '';
//     const clone = el.cloneNode(true);
//     clone.querySelectorAll('.visually-hidden, [aria-hidden="true"]').forEach(n => n.remove());
//     return clone.textContent.trim();
//   }

//   function captureSnapshot(shadow) {
//     const discounted = cleanText(shadow.querySelector('[part~="rc-purchase-option__discounted-price"]'));
//     const original   = cleanText(shadow.querySelector('[part~="rc-purchase-option__original-price"]'));
//     const onetime    = cleanText(shadow.querySelector('[part~="rc-purchase-option__price"]'));

//     // Per-unit: try known part attrs first, then broad text scan for "€X.XX / PORTION"
//     const perUnitSelectors = [
//       '[part~="rc-purchase-option__price-per-unit"]',
//       '[part~="rc-price-per-unit"]',
//       '.rc-price-per-unit',
//       '[class*="per-unit"]',
//       '[part*="per-unit"]',
//     ];
//     let perUnit = '';
//     for (const sel of perUnitSelectors) {
//       const el = shadowQueryAll(shadow, sel)[0];
//       if (el?.textContent?.trim()) { perUnit = el.textContent.trim(); break; }
//     }
//     if (!perUnit) {
//       const allTextNodes = [];
//       shadowQueryAll(shadow, '*').forEach(el => {
//         el.childNodes.forEach(n => {
//           if (n.nodeType === Node.TEXT_NODE) allTextNodes.push(n.textContent.trim());
//         });
//       });
//       perUnit = allTextNodes.find(t => /[€$£]\d[\d.,]+\s*\//.test(t)) ?? '';
//     }

//     return { discounted, original, onetime, perUnit };
//   }

//   function pause(ms) { return new Promise(r => setTimeout(r, ms)); }
 
//   // function injectStyles() {
//   //   if (document.getElementById('rc-flat-styles')) return;
//   //   const s = document.createElement('style');
//   //   s.id = 'rc-flat-styles';
//   //   s.textContent = `
//   //     @import url('https://fonts.googleapis.com/css2?family=DM+Mono:wght@500&family=DM+Sans:wght@400;500;600;700&display=swap');

//   //     .rc-flat-ui {
//   //       display: flex;
//   //       flex-direction: column;
//   //       gap: 10px;
//   //       margin-bottom: 16px;
//   //       font-family: 'DM Sans', sans-serif;
//   //       width:100%;
//   //     }

//   //     /* ── Card ── */
//   //     .rc-flat-card {
//   //       width: 100%;
//   //       box-sizing: border-box;
//   //       background: #fff;
//   //       border: 1.5px solid #ddd;
//   //       border-radius: 10px;
//   //       cursor: pointer;
//   //       text-align: left;
//   //       overflow: hidden;
//   //       padding: 0;
//   //       outline: none;
//   //       transition: border-color 0.15s, box-shadow 0.15s;
//   //     }
//   //     .rc-flat-card:hover { border-color: #aaa; }
//   //     .rc-flat-card.active {
//   //       border-color: #1a2e44;
//   //       box-shadow: 0 0 0 1px #1a2e44;
//   //     }

//   //     /* ── Banner ── */
//   //     .rc-flat-card__banner {
//   //       width: 100%;
//   //       background: #1a2e44;
//   //       color: #fff;
//   //       font-size: 0.6rem;
//   //       font-weight: 700;
//   //       letter-spacing: 0.14em;
//   //       text-transform: uppercase;
//   //       text-align: center;
//   //       padding: 5px 0;
//   //       display: block;
//   //     }
//   //     .rc-flat-card__banner.green { background: #1a4f35; }

//   //     /* ── Body ── */
//   //     .rc-flat-card__body { padding: 14px 16px; }

//   //     /* ── Main row ── */
//   //     .rc-flat-card__main {
//   //       display: flex;
//   //       align-items: center;
//   //       gap: 10px;
//   //       flex-wrap: nowrap;
//   //     }

//   //     /* Radio dot */
//   //     .rc-flat-card__dot {
//   //       flex-shrink: 0;
//   //       width: 20px;
//   //       height: 20px;
//   //       border-radius: 50%;
//   //       border: 2px solid #bbb;
//   //       display: flex;
//   //       align-items: center;
//   //       justify-content: center;
//   //       transition: border-color 0.15s;
//   //     }
//   //     .rc-flat-card.active .rc-flat-card__dot { border-color: #1a2e44; }
//   //     .rc-flat-card__dot::after {
//   //       content: '';
//   //       width: 10px;
//   //       height: 10px;
//   //       border-radius: 50%;
//   //       background: #1a2e44;
//   //       opacity: 0;
//   //       transition: opacity 0.15s;
//   //     }
//   //     .rc-flat-card.active .rc-flat-card__dot::after { opacity: 1; }

//   //     /* Title + per-portion */
//   //     .rc-flat-card__label-group {
//   //       display: flex;
//   //       align-items: baseline;
//   //       gap: 8px;
//   //       flex-shrink: 0;
//   //     }
//   //     .rc-flat-card__title {
//   //       font-size: 0.8rem;
//   //       font-weight: 800;
//   //       color: #111;
//   //       text-transform: uppercase;
//   //       letter-spacing: 0.05em;
//   //       white-space: nowrap;
//   //     }
//   //     .rc-flat-card__per {
//   //       font-size: 0.72rem;
//   //       color: #555;
//   //       white-space: nowrap;
//   //       font-weight: 400;
//   //     }

//   //     /* Right side: save badge + crossed price + new price */
//   //     .rc-flat-card__right {
//   //       display: flex;
//   //       align-items: center;
//   //       gap: 8px;
//   //       margin-left: auto;
//   //       flex-shrink: 0;
//   //     }
//   //     .rc-flat-card__save {
//   //       font-size: 0.65rem;
//   //       font-weight: 700;
//   //       color: #1a4f35;
//   //       background: #d4f0e0;
//   //       padding: 3px 8px;
//   //       border-radius: 4px;
//   //       letter-spacing: 0.04em;
//   //       white-space: nowrap;
//   //     }
//   //     .rc-flat-card__original {
//   //       font-size: 0.82rem;
//   //       color: #aaa;
//   //       text-decoration: line-through;
//   //       font-weight: 400;
//   //     }
//   //     .rc-flat-card__price {
//   //       font-size: 1.3rem;
//   //       font-weight: 800;
//   //       color: #111;
//   //       font-family: 'DM Mono', monospace;
//   //       white-space: nowrap;
//   //     }

//   //     /* ── Benefits ── */
//   //     .rc-flat-card__benefits {
//   //       display: none;
//   //       margin-top: 12px;
//   //       padding-top: 10px;
//   //       border-top: 1px solid #eee;
//   //       font-size: 0.78rem;
//   //       color: #333;
//   //       line-height: 1.6;
//   //     }
//   //     .rc-flat-card.active .rc-flat-card__benefits { display: block; }
//   //     .rc-flat-card__benefits ul {
//   //       list-style: none;
//   //       margin: 0;
//   //       padding: 0;
//   //       display: flex;
//   //       flex-direction: column;
//   //       gap: 6px;
//   //     }
//   //     .rc-flat-card__benefits li {
//   //       display: flex;
//   //       align-items: flex-start;
//   //       gap: 8px;
//   //       padding-bottom: 6px;
//   //       border-bottom: 1px solid #f0f0f0;
//   //     }
//   //     .rc-flat-card__benefits li:last-child { border-bottom: none; padding-bottom: 0; }
//   //     .rc-flat-card__benefits li::before {
//   //       content: '✓';
//   //       color: #1a4f35;
//   //       font-weight: 700;
//   //       flex-shrink: 0;
//   //     }
//   //     .rc-flat-card__benefits p { margin: 0; }

//   //     /* ── OR divider ── */
//   //     .rc-flat-divider {
//   //       display: flex;
//   //       align-items: center;
//   //       gap: 12px;
//   //       font-size: 0.7rem;
//   //       color: #bbb;
//   //       font-weight: 700;
//   //       letter-spacing: 0.14em;
//   //       text-transform: uppercase;
//   //       font-family: 'DM Sans', sans-serif;
//   //     }
//   //     .rc-flat-divider::before,
//   //     .rc-flat-divider::after {
//   //       content: '';
//   //       flex: 1;
//   //       height: 1px;
//   //       background: #e0e0e0;
//   //     }

//   //     /* ── One-time card ── */
//   //     .rc-flat-card.onetime { border-color: #e8e8e8; background: #fafafa; }
//   //     .rc-flat-card.onetime.active {
//   //       border-color: #1a2e44;
//   //       background: #fff;
//   //       box-shadow: 0 0 0 1px #1a2e44;
//   //     }
//   //   `;
//   //   document.head.appendChild(s);
//   // }

//   // Wait until the widget's shadowRoot exists AND has the key purchase option inside
//   function waitForShadow(widget, timeout = 8000) {
//     return new Promise((resolve, reject) => {
//       const start = Date.now();
//       function check() {
//         const shadow = widget.shadowRoot;
//         if (shadow && shadow.querySelector('input[name="purchaseOption"]')) {
//           resolve(shadow);
//         } else if (Date.now() - start > timeout) {
//           reject(new Error('[rc-flat] Timed out waiting for shadow DOM'));
//         } else {
//           requestAnimationFrame(check);
//         }
//       }
//       check();
//     });
//   }

//   function processWidget(widget) {
//     if (widget._rcFlatProcessed) return;
//     widget._rcFlatProcessed = true;

//     waitForShadow(widget)
//       .then(async (shadow) => {
//         await buildUI(widget, shadow);
//       })
//       .catch(err => console.warn(err));
//   }

//   function init() {
//     // Handle widgets already in the DOM
//     document.querySelectorAll(WIDGET_TAG).forEach(processWidget);

//     // Handle widgets injected later
//     new MutationObserver(mutations => {
//       mutations.forEach(mutation => {
//         mutation.addedNodes.forEach(node => {
//           if (node.nodeType !== Node.ELEMENT_NODE) return;
//           // Direct match
//           if (node.matches?.(WIDGET_TAG)) processWidget(node);
//           // Nested inside added node
//           node.querySelectorAll?.(WIDGET_TAG).forEach(processWidget);
//         });
//       });
//     }).observe(document.body, { childList: true, subtree: true });
//   }

//   async function buildUI(widget, shadow) {
//       if (widget.previousElementSibling?.classList?.contains('rc-flat-ui')) return;
//       {
//         if (!shadow) return;

//         // injectStyles();
//         widget.style.display = 'none';

//         const subInput     = shadow.querySelector('input[name="purchaseOption"][value="subscription"]');
//         const onetimeInput = shadow.querySelector('input[name="purchaseOption"][value="onetime"]');
//         const planLabels   = shadowQueryAll(shadow, 'label[part="rc-plans-radio-button"]');

//         const wrap = document.createElement('div');
//         wrap.className = 'rc-flat-ui';
//         const cards = [];

//         function setActive(card) {
//           cards.forEach(c => c.card.classList.remove('active'));
//           card.classList.add('active');
//         }
//         function syncBenefits(card) {
//           card.querySelector('.rc-flat-card__benefits').innerHTML = getBenefitsHTML(shadow);
//         }

//         const bannerLabels  = ['MOST POPULAR', 'BEST VALUE'];
//         const bannerClasses = ['', 'green'];

//         // ── Subscription plan cards ──
//         planLabels.forEach((label, i) => {
//           const radio = label.querySelector('input[type="radio"]');
//           if (!radio) return;

//           const ariaLabel = radio.getAttribute('aria-label') || '';
//           const saveMatch = ariaLabel.match(/Spare\s([\d.]+%)/);
//           const savePct   = saveMatch ? saveMatch[1] : '';
//           const is3Month  = ariaLabel.toLowerCase().includes('90');
//           const titleText = is3Month ? 'Subscribe &amp; Save - 3 Months' : 'Subscribe &amp; Save';
//           const isActive  = !!(radio.checked && subInput?.checked);

//           const card = document.createElement('button');
//           card.type = 'button';
//           card.className = 'rc-flat-card' + (isActive ? ' active' : '');
//           card.innerHTML = `
//             <div class="rc-flat-card__banner ${bannerClasses[i]}">${bannerLabels[i] ?? ''}</div>
//             <div class="rc-flat-card__body">
//               <div class="rc-flat-card__main">
//                 <div class="rc-flat-card__dot"></div>
//                 <div class="rc-flat-card__label-group">
//                   <span class="rc-flat-card__title">${titleText}</span>
//                   <span class="rc-flat-card__per"></span>
//                 </div>
//                 <div class="rc-flat-card__right">
//                   ${savePct ? `<span class="rc-flat-card__save">SAVE ${savePct}</span>` : ''}
//                   <span class="rc-flat-card__original"></span>
//                   <span class="rc-flat-card__price"></span>
//                 </div>
//               </div>
//               <div class="rc-flat-card__benefits"></div>
//             </div>
//           `;

//           card.addEventListener('click', () => {
//             if (subInput && !subInput.checked) subInput.click();
//             radio.click();
//             setActive(card);
//             setTimeout(() => syncBenefits(card), 60);
//           });

//           wrap.appendChild(card);
//           cards.push({ card, radio, type: 'plan' });
//         });

//         // OR divider
//         const divider = document.createElement('div');
//         divider.className = 'rc-flat-divider';
//         divider.textContent = 'OR';
//         wrap.appendChild(divider);

//         // One-time card
//         if (onetimeInput) {
//           const card = document.createElement('button');
//           card.type = 'button';
//           card.className = 'rc-flat-card onetime' + (onetimeInput.checked ? ' active' : '');
//           card.innerHTML = `
//             <div class="rc-flat-card__body">
//               <div class="rc-flat-card__main">
//                 <div class="rc-flat-card__dot"></div>
//                 <div class="rc-flat-card__label-group">
//                   <span class="rc-flat-card__title">Buy One Time</span>
//                   <span class="rc-flat-card__per"></span>
//                 </div>
//                 <div class="rc-flat-card__right">
//                   <span class="rc-flat-card__price"></span>
//                 </div>
//               </div>
//               <div class="rc-flat-card__benefits"></div>
//             </div>
//           `;
//           card.addEventListener('click', () => {
//             onetimeInput.click();
//             setActive(card);
//             setTimeout(() => syncBenefits(card), 60);
//           });
//           wrap.appendChild(card);
//           cards.push({ card, radio: onetimeInput, type: 'onetime' });
//         }

//         widget.parentNode.insertBefore(wrap, widget);

//         // ── Silently cycle, capture snapshot per plan ──
//         const origSubChecked  = subInput?.checked;
//         const origPlanChecked = planLabels.map(l => l.querySelector('input[type="radio"]')).find(r => r?.checked);

//         for (const { card, radio, type } of cards) {
//           if (type === 'plan') {
//             if (subInput && !subInput.checked) subInput.click();
//             radio.click();
//           } else {
//             onetimeInput.click();
//           }
//           await pause(120);

//           const snap = captureSnapshot(shadow);

//           if (type === 'plan') {
//             card.querySelector('.rc-flat-card__original').textContent = snap.original;
//             card.querySelector('.rc-flat-card__price').textContent    = snap.discounted;
//           } else {
//             card.querySelector('.rc-flat-card__price').textContent    = snap.onetime;
//           }
//           if (snap.perUnit) {
//             card.querySelector('.rc-flat-card__per').textContent = snap.perUnit;
//           }

//           syncBenefits(card);
//         }

//         // Restore
//         if (origSubChecked && origPlanChecked) { subInput.click(); origPlanChecked.click(); }
//         else if (!origSubChecked && onetimeInput) onetimeInput.click();

//         // MutationObserver — keep active card benefits live
//         const benefitsEl = shadowQueryAll(shadow, 'rc-benefits')[0];
//         if (benefitsEl?.shadowRoot) {
//           new MutationObserver(() => {
//             const active = cards.find(({ card }) => card.classList.contains('active'));
//             if (active) syncBenefits(active.card);
//           }).observe(benefitsEl.shadowRoot, { childList: true, subtree: true });
//         }
//       }
//   }

//   document.readyState === 'loading'
//     ? document.addEventListener('DOMContentLoaded', init)
//     : init();
// })();


// (function () {
//   const WIDGET_TAG = 'recharge-subscription-widget';

//   /* ─── Shadow DOM helpers ──────────────────────────────────────── */
//   function shadowQueryAll(root, selector) {
//     const results = [];
//     (function walk(r) {
//       r.querySelectorAll(selector).forEach(el => results.push(el));
//       r.querySelectorAll('*').forEach(el => { if (el.shadowRoot) walk(el.shadowRoot); });
//     })(root);
//     return results;
//   }

//   function getBenefitsHTML(shadow) {
//     const el = shadowQueryAll(shadow, 'rc-benefits')[0];
//     const list = el?.shadowRoot?.querySelector('.rc-benefits__list');
//     return list ? list.innerHTML : '';
//   }

//   function cleanText(el) {
//     if (!el) return '';
//     const clone = el.cloneNode(true);
//     clone.querySelectorAll('.visually-hidden, [aria-hidden="true"]').forEach(n => n.remove());
//     return clone.textContent.trim();
//   }

//   /* ─── Price helpers ───────────────────────────────────────────── */
//   function pause(ms) { return new Promise(r => setTimeout(r, ms)); }

//   // "€59,00" or "€50.46" → 59.00
//   function parsePrice(str) {
//     if (!str) return null;
//     const cleaned = str.replace(/[^0-9.,]/g, '').replace(',', '.');
//     return parseFloat(cleaned) || null;
//   }

//   // number → "€59" (no cents)
//   function formatWhole(num, symbol) {
//     if (num === null || num === undefined) return '';
//     return (symbol || '€') + Math.round(num);
//   }

//   // detect "€" / "$" etc from string
//   function currencySymbol(str) {
//     const m = str?.match(/[€$£]/);
//     return m ? m[0] : '€';
//   }

//   // "Zahle alle 90 Tage" with baseDays=30 → multiplier 3
//   function detectMultiplier(ariaLabel, baseDays) {
//     baseDays = baseDays || 30;
//     const m = ariaLabel.match(/alle\s+(\d+)\s+Tage/i)
//            || ariaLabel.match(/every\s+(\d+)\s+days?/i);
//     if (m) return Math.round(parseInt(m[1], 10) / baseDays) || 1;
//     return 1;
//   }

//   /* ─── Capture shadow DOM snapshot ────────────────────────────── */
//   function captureSnapshot(shadow) {
//     const discounted = cleanText(shadow.querySelector('[part~="rc-purchase-option__discounted-price"]'));
//     const original   = cleanText(shadow.querySelector('[part~="rc-purchase-option__original-price"]'));
//     const onetime    = cleanText(shadow.querySelector('[part~="rc-purchase-option__price"]'));

//     const perUnitSelectors = [
//       '[part~="rc-purchase-option__price-per-unit"]',
//       '[part~="rc-price-per-unit"]',
//       '.rc-price-per-unit',
//       '[class*="per-unit"]',
//       '[part*="per-unit"]',
//     ];
//     let perUnit = '';
//     for (const sel of perUnitSelectors) {
//       const el = shadowQueryAll(shadow, sel)[0];
//       if (el?.textContent?.trim()) { perUnit = el.textContent.trim(); break; }
//     }
//     if (!perUnit) {
//       const texts = [];
//       shadowQueryAll(shadow, '*').forEach(el => {
//         el.childNodes.forEach(n => {
//           if (n.nodeType === Node.TEXT_NODE) texts.push(n.textContent.trim());
//         });
//       });
//       perUnit = texts.find(t => /[€$£]\d[\d.,]+\s*\//.test(t)) || '';
//     }

//     return { discounted, original, onetime, perUnit };
//   }

  

//   /* ─── Wait for shadow DOM to be ready ────────────────────────── */
//   function waitForShadow(widget, timeout) {
//     timeout = timeout || 8000;
//     return new Promise(function(resolve, reject) {
//       var start = Date.now();
//       function check() {
//         var shadow = widget.shadowRoot;
//         if (shadow && shadow.querySelector('input[name="purchaseOption"]')) {
//           resolve(shadow);
//         } else if (Date.now() - start > timeout) {
//           reject(new Error('[rc-flat] Timed out waiting for shadow DOM'));
//         } else {
//           requestAnimationFrame(check);
//         }
//       }
//       check();
//     });
//   }

//   /* ─── Build UI ────────────────────────────────────────────────── */
//   async function buildUI(widget, shadow) {
//     if (widget.previousElementSibling && widget.previousElementSibling.classList.contains('rc-flat-ui')) return;
//     widget.style.display = 'none';

//     const subInput     = shadow.querySelector('input[name="purchaseOption"][value="subscription"]');
//     const onetimeInput = shadow.querySelector('input[name="purchaseOption"][value="onetime"]');
//     const planLabels   = shadowQueryAll(shadow, 'label[part="rc-plans-radio-button"]');

//     const wrap = document.createElement('div');
//     wrap.className = 'rc-flat-ui';
//     const cards = [];

//     function setActive(card) {
//       cards.forEach(function(c) { c.card.classList.remove('active'); });
//       card.classList.add('active');
//     }
//     function syncBenefits(card) {
//       card.querySelector('.rc-flat-card__benefits').innerHTML = getBenefitsHTML(shadow);
//     }

//     const bannerLabels  = ['MOST POPULAR', 'BEST VALUE'];
//     const bannerClasses = ['', 'green'];

//     /* ── Subscription plan cards ── */
//     planLabels.forEach(function(label, i) {
//       const radio = label.querySelector('input[type="radio"]');
//       if (!radio) return;

//       const ariaLabel  = radio.getAttribute('aria-label') || '';
//       const multiplier = detectMultiplier(ariaLabel);
//       const is3Month   = multiplier > 1;
//       const titleText  = is3Month
//         ? 'Subscribe &amp; Save - ' + multiplier + ' Months'
//         : 'Subscribe &amp; Save';
//       const isActive   = !!(radio.checked && subInput && subInput.checked);

//       const card = document.createElement('button');
//       card.type = 'button';
//       card.className = 'rc-flat-card' + (isActive ? ' active' : '');
//       card.dataset.multiplier = multiplier;
//       card.innerHTML = `
//         <div class="rc-flat-card__banner ${bannerClasses[i] || ''}">${bannerLabels[i] || ''}</div>
//         <div class="rc-flat-card__body">
//           <div class="rc-flat-card__main">
//             <div class="rc-flat-card__dot"></div>
//             <div class="rc-flat-card__label-group">
//               <span class="rc-flat-card__title">${titleText}</span>
//               <span class="rc-flat-card__per"></span>
//             </div>
//             <div class="rc-flat-card__right">
//               <span class="rc-flat-card__save" style="display:none"></span>
//               <span class="rc-flat-card__original"></span>
//               <span class="rc-flat-card__price"></span>
//             </div>
//           </div>
//           <div class="rc-flat-card__benefits"></div>
//         </div>
//       `;

//       card.addEventListener('click', function() {
//         if (subInput && !subInput.checked) subInput.click();
//         radio.click();
//         setActive(card);
//         setTimeout(function() { syncBenefits(card); }, 60);
//       });

//       wrap.appendChild(card);
//       cards.push({ card: card, radio: radio, type: 'plan' });
//     });

//     /* ── OR divider ── */
//     const divider = document.createElement('div');
//     divider.className = 'rc-flat-divider';
//     divider.textContent = 'OR';
//     wrap.appendChild(divider);

//     /* ── One-time card ── */
//     if (onetimeInput) {
//       const card = document.createElement('button');
//       card.type = 'button';
//       card.className = 'rc-flat-card onetime' + (onetimeInput.checked ? ' active' : '');
//       card.dataset.multiplier = '1';
//       card.innerHTML = `
//         <div class="rc-flat-card__body">
//           <div class="rc-flat-card__main">
//             <div class="rc-flat-card__dot"></div>
//             <div class="rc-flat-card__label-group">
//               <span class="rc-flat-card__title">Buy One Time</span>
//               <span class="rc-flat-card__per"></span>
//             </div>
//             <div class="rc-flat-card__right">
//               <span class="rc-flat-card__price"></span>
//             </div>
//           </div>
//           <div class="rc-flat-card__benefits"></div>
//         </div>
//       `;
//       card.addEventListener('click', function() {
//         onetimeInput.click();
//         setActive(card);
//         setTimeout(function() { syncBenefits(card); }, 60);
//       });
//       wrap.appendChild(card);
//       cards.push({ card: card, radio: onetimeInput, type: 'onetime' });
//     }

//     widget.parentNode.insertBefore(wrap, widget);

//     /* ── Silently cycle each option, snapshot prices ── */
//     const origSubChecked  = subInput && subInput.checked;
//     const origPlanChecked = planLabels
//       .map(function(l) { return l.querySelector('input[type="radio"]'); })
//       .find(function(r) { return r && r.checked; });

//     // First pass: collect one-time price for saving calculation
//     let onetimeNum = null;
//     let sym = '€';
//     if (onetimeInput) {
//       onetimeInput.click();
//       await pause(120);
//       const snap = captureSnapshot(shadow);
//       onetimeNum = parsePrice(snap.onetime);
//       if (snap.onetime) sym = currencySymbol(snap.onetime);
//     }

//     // Second pass: cycle all cards
//     for (let i = 0; i < cards.length; i++) {
//       const { card, radio, type } = cards[i];

//       if (type === 'plan') {
//         if (subInput && !subInput.checked) subInput.click();
//         radio.click();
//       } else {
//         onetimeInput.click();
//       }
//       await pause(120);

//       const snap       = captureSnapshot(shadow);
//       const multiplier = parseInt(card.dataset.multiplier, 10) || 1;

//       if (type === 'plan') {
//         const discountedNum = parsePrice(snap.discounted);
//         // Full price for multi-month = discounted * multiplier
//         const fullPrice = discountedNum !== null ? discountedNum * multiplier : null;
//         // Crossed price = onetime * multiplier (what you'd pay without sub)
//         const crossedNum = onetimeNum !== null ? onetimeNum * multiplier : parsePrice(snap.original);

//         card.querySelector('.rc-flat-card__original').textContent = formatWhole(crossedNum, sym);
//         card.querySelector('.rc-flat-card__price').textContent    = formatWhole(fullPrice, sym);

//         // Save = onetime price (single) - discounted (single), then × multiplier
//         if (onetimeNum !== null && discountedNum !== null) {
//           const saveAmt = (onetimeNum - discountedNum) * multiplier;
//           const saveEl  = card.querySelector('.rc-flat-card__save');
//           saveEl.textContent  = 'SAVE ' + formatWhole(saveAmt, sym);
//           saveEl.style.display = '';
//         }

//         // Per unit price: already per-unit from widget, no multiplication needed
//         if (snap.perUnit) {
//           card.querySelector('.rc-flat-card__per').textContent = snap.perUnit;
//         }
//       } else {
//         // One-time: just show whole price, no badge
//         const onetimeWholeNum = parsePrice(snap.onetime);
//         card.querySelector('.rc-flat-card__price').textContent = formatWhole(onetimeWholeNum, sym);
//         if (snap.perUnit) {
//           card.querySelector('.rc-flat-card__per').textContent = snap.perUnit;
//         }
//       }

//       syncBenefits(card);
//     }

//     // Restore original selection
//     if (origSubChecked && origPlanChecked) { subInput.click(); origPlanChecked.click(); }
//     else if (!origSubChecked && onetimeInput) onetimeInput.click();

//     /* ── MutationObserver: keep active card benefits live ── */
//     const benefitsEl = shadowQueryAll(shadow, 'rc-benefits')[0];
//     if (benefitsEl && benefitsEl.shadowRoot) {
//       new MutationObserver(function() {
//         const active = cards.find(function(c) { return c.card.classList.contains('active'); });
//         if (active) syncBenefits(active.card);
//       }).observe(benefitsEl.shadowRoot, { childList: true, subtree: true });
//     }
//   }

//   /* ─── Process widget ──────────────────────────────────────────── */
//   function processWidget(widget) {
//     if (widget._rcFlatProcessed) return;
//     widget._rcFlatProcessed = true;
//     waitForShadow(widget)
//       .then(function(shadow) { return buildUI(widget, shadow); })
//       .catch(function(err) { console.warn(err); });
//   }

//   /* ─── Init + DOM observer ─────────────────────────────────────── */
//   function init() {
//     document.querySelectorAll(WIDGET_TAG).forEach(processWidget);

//     new MutationObserver(function(mutations) {
//       mutations.forEach(function(mutation) {
//         mutation.addedNodes.forEach(function(node) {
//           if (node.nodeType !== Node.ELEMENT_NODE) return;
//           if (node.matches && node.matches(WIDGET_TAG)) processWidget(node);
//           if (node.querySelectorAll) node.querySelectorAll(WIDGET_TAG).forEach(processWidget);
//         });
//       });
//     }).observe(document.body, { childList: true, subtree: true });
//   }

//   document.readyState === 'loading'
//     ? document.addEventListener('DOMContentLoaded', init)
//     : init();
// })();

//Final Working Script
// (function () {
//   const WIDGET_TAG = 'recharge-subscription-widget';

//   /* ─── Shadow DOM helpers ──────────────────────────────────────── */
//   function shadowQueryAll(root, selector) {
//     const results = [];
//     (function walk(r) {
//       r.querySelectorAll(selector).forEach(el => results.push(el));
//       r.querySelectorAll('*').forEach(el => { if (el.shadowRoot) walk(el.shadowRoot); });
//     })(root);
//     return results;
//   }

//   function getBenefitsHTML(shadow) {
//     const el = shadowQueryAll(shadow, 'rc-benefits')[0];
//     const list = el?.shadowRoot?.querySelector('.rc-benefits__list');
//     return list ? list.innerHTML : '';
//   }

//   function cleanText(el) {
//     if (!el) return '';
//     const clone = el.cloneNode(true);
//     clone.querySelectorAll('.visually-hidden, [aria-hidden="true"]').forEach(n => n.remove());
//     return clone.textContent.trim();
//   }

//   /* ─── Price helpers ───────────────────────────────────────────── */
//   function pause(ms) { return new Promise(r => setTimeout(r, ms)); }

//   // "€59,00" or "€50.46" → 59.00
//   function parsePrice(str) {
//     if (!str) return null;
//     const cleaned = str.replace(/[^0-9.,]/g, '').replace(',', '.');
//     return parseFloat(cleaned) || null;
//   }

//   // number → "€59" (no cents)
//   function formatWhole(num, symbol) {
//     if (num === null || num === undefined) return '';
//     return (symbol || '€') + Math.round(num);
//   }

//   // detect "€" / "$" etc from string
//   function currencySymbol(str) {
//     const m = str?.match(/[€$£]/);
//     return m ? m[0] : '€';
//   }

//   // Read delivery interval and billing interval directly from the plan label DOM
//   // delivery interval = rc-plans-button__interval text node (e.g. "30 Tage")
//   // billing interval  = nested rc-plans-button__discount inside interval (e.g. "Zahle alle 90 Tage")
//   // multiplier = billingDays / deliveryDays
//   function detectMultiplier(label) {
//     const intervalEl = label.querySelector('[part~="rc-plans-button__interval"]');
//     if (!intervalEl) return 1;

//     // Delivery days: text node directly inside interval span (excludes nested spans)
//     const deliveryText = Array.from(intervalEl.childNodes)
//       .filter(n => n.nodeType === Node.TEXT_NODE)
//       .map(n => n.textContent.trim())
//       .join(' ');
//     const deliveryMatch = deliveryText.match(/(\d+)/);
//     const deliveryDays  = deliveryMatch ? parseInt(deliveryMatch[1], 10) : null;

//     // Billing days: nested span inside interval (e.g. "Zahle alle 90 Tage")
//     const billingEl    = intervalEl.querySelector('[part~="rc-plans-button__discount"]');
//     const billingText  = billingEl ? billingEl.textContent : '';
//     const billingMatch = billingText.match(/(\d+)/);
//     const billingDays  = billingMatch ? parseInt(billingMatch[1], 10) : null;

//     if (deliveryDays && billingDays && deliveryDays > 0) {
//       return Math.round(billingDays / deliveryDays) || 1;
//     }
//     return 1;
//   }

//   /* ─── Capture shadow DOM snapshot ────────────────────────────── */
//   function captureSnapshot(shadow) {
//     const discounted = cleanText(shadow.querySelector('[part~="rc-purchase-option__discounted-price"]'));
//     const original   = cleanText(shadow.querySelector('[part~="rc-purchase-option__original-price"]'));
//     const onetime    = cleanText(shadow.querySelector('[part~="rc-purchase-option__price"]'));

//     return { discounted, original, onetime };
//   }

  

//   /* ─── Wait for shadow DOM to be ready ────────────────────────── */
//   function waitForShadow(widget, timeout) {
//     timeout = timeout || 8000;
//     return new Promise(function(resolve, reject) {
//       var start = Date.now();
//       function check() {
//         var shadow = widget.shadowRoot;
//         if (shadow && shadow.querySelector('input[name="purchaseOption"]')) {
//           resolve(shadow);
//         } else if (Date.now() - start > timeout) {
//           reject(new Error('[rc-flat] Timed out waiting for shadow DOM'));
//         } else {
//           requestAnimationFrame(check);
//         }
//       }
//       check();
//     });
//   }

//   /* ─── Build UI ────────────────────────────────────────────────── */
//   async function buildUI(widget, shadow) {
//     if (widget.previousElementSibling && widget.previousElementSibling.classList.contains('rc-flat-ui')) return;
//     widget.style.display = 'none';

//     // Quantity input on the page (updates per plan)
//     const qtyInput = document.querySelector('input[name="quantity"]');

//     function setQty(val) {
//       if (!qtyInput) return;
//       qtyInput.value = val;
//       // Trigger change/input events so Shopify theme re-calculates totals
//       qtyInput.dispatchEvent(new Event('input',  { bubbles: true }));
//       qtyInput.dispatchEvent(new Event('change', { bubbles: true }));
//     }

//     const subInput     = shadow.querySelector('input[name="purchaseOption"][value="subscription"]');
//     const onetimeInput = shadow.querySelector('input[name="purchaseOption"][value="onetime"]');
//     const planLabels   = shadowQueryAll(shadow, 'label[part="rc-plans-radio-button"]');

//     const wrap = document.createElement('div');
//     wrap.className = 'rc-flat-ui';
//     const cards = [];

//     function setActive(card) {
//       cards.forEach(function(c) { c.card.classList.remove('active'); });
//       card.classList.add('active');
//     }
//     function syncBenefits(card) {
//       card.querySelector('.rc-flat-card__benefits').innerHTML = getBenefitsHTML(shadow);
//     }

//     const bannerLabels  = ['MOST POPULAR', 'BEST VALUE'];
//     const bannerClasses = ['', 'green'];

//     /* ── Subscription plan cards ── */
//     planLabels.forEach(function(label, i) {
//       const radio = label.querySelector('input[type="radio"]');
//       if (!radio) return;

//       const ariaLabel  = radio.getAttribute('aria-label') || '';
//       const multiplier = detectMultiplier(label);
//       const is3Month   = multiplier > 1;
//       const titleText  = is3Month
//         ? 'Subscribe &amp; Save - ' + multiplier + ' Months'
//         : 'Subscribe &amp; Save';
//       const isActive   = !!(radio.checked && subInput && subInput.checked);

//       const card = document.createElement('button');
//       card.type = 'button';
//       card.className = 'rc-flat-card' + (isActive ? ' active' : '');
//       card.innerHTML = `
//         <div class="rc-flat-card__banner ${bannerClasses[i] || ''}">${bannerLabels[i] || ''}</div>
//         <div class="rc-flat-card__body">
//           <div class="rc-flat-card__main">
//             <div class="rc-flat-card__dot"></div>
//             <div class="rc-flat-card__label-group">
//               <span class="rc-flat-card__title">${titleText}</span>
//               <span class="rc-flat-card__per"></span>
//             </div>
//             <div class="rc-flat-card__right">
//               <span class="rc-flat-card__save" style="display:none"></span>
//               <span class="rc-flat-card__original"></span>
//               <span class="rc-flat-card__price"></span>
//             </div>
//           </div>
//           <div class="rc-flat-card__benefits"></div>
//         </div>
//       `;

//       card.addEventListener('click', function() {
//         if (subInput && !subInput.checked) subInput.click();
//         radio.click();
//         setActive(card);
//         setTimeout(function() { syncBenefits(card); }, 60);
//       });

//       wrap.appendChild(card);
//       cards.push({ card: card, radio: radio, type: 'plan' });
//     });

//     /* ── OR divider ── */
//     const divider = document.createElement('div');
//     divider.className = 'rc-flat-divider';
//     divider.textContent = 'OR';
//     wrap.appendChild(divider);

//     /* ── One-time card ── */
//     if (onetimeInput) {
//       const card = document.createElement('button');
//       card.type = 'button';
//       card.className = 'rc-flat-card onetime' + (onetimeInput.checked ? ' active' : '');
//       card.innerHTML = `
//         <div class="rc-flat-card__body">
//           <div class="rc-flat-card__main">
//             <div class="rc-flat-card__dot"></div>
//             <div class="rc-flat-card__label-group">
//               <span class="rc-flat-card__title">Buy One Time</span>
//               <span class="rc-flat-card__per"></span>
//             </div>
//             <div class="rc-flat-card__right">
//               <span class="rc-flat-card__price"></span>
//             </div>
//           </div>
//           <div class="rc-flat-card__benefits"></div>
//         </div>
//       `;
//       card.addEventListener('click', function() {
//         onetimeInput.click();
//         setActive(card);
//         setQty(1);
//         setTimeout(function() { syncBenefits(card); }, 60);
//       });
//       wrap.appendChild(card);
//       cards.push({ card: card, radio: onetimeInput, type: 'onetime' });
//     }

//     widget.parentNode.insertBefore(wrap, widget);

//     /* ── Silently cycle each option, snapshot prices ── */
//     const origSubChecked  = subInput && subInput.checked;
//     const origPlanChecked = planLabels
//       .map(function(l) { return l.querySelector('input[type="radio"]'); })
//       .find(function(r) { return r && r.checked; });

//     // First pass: collect one-time price for saving calculation
//     let onetimeNum = null;
//     let sym = '€';
//     if (onetimeInput) {
//       onetimeInput.click();
//       await pause(120);
//       const snap = captureSnapshot(shadow);
//       onetimeNum = parsePrice(snap.onetime);
//       if (snap.onetime) sym = currencySymbol(snap.onetime);
//     }

//     // Second pass: cycle all cards
//     for (let i = 0; i < cards.length; i++) {
//       const { card, radio, type } = cards[i];

//       if (type === 'plan') {
//         if (subInput && !subInput.checked) subInput.click();
//         radio.click();
//       } else {
//         onetimeInput.click();
//       }
//       await pause(120);

//       const snap       = captureSnapshot(shadow);
//       const multiplier = qtyInput ? (parseInt(qtyInput.value, 10) || 1) : 1;

//       if (type === 'plan') {
//         const discountedNum = parsePrice(snap.discounted);
//         // Full price = discounted x qty
//         const fullPrice  = discountedNum !== null ? discountedNum * multiplier : null;
//         // Crossed price = onetime x qty
//         const crossedNum = onetimeNum !== null ? onetimeNum * multiplier : parsePrice(snap.original);

//         card.querySelector('.rc-flat-card__original').textContent = formatWhole(crossedNum, sym);
//         card.querySelector('.rc-flat-card__price').textContent    = formatWhole(fullPrice, sym);

//         // Save = (onetime - discounted) x qty
//         if (onetimeNum !== null && discountedNum !== null) {
//           const saveAmt = (onetimeNum - discountedNum) * multiplier;
//           const saveEl  = card.querySelector('.rc-flat-card__save');
//           saveEl.textContent   = 'SAVE ' + formatWhole(saveAmt, sym);
//           saveEl.style.display = '';
//         }

//         // Per unit = discounted / qty  e.g. 120 / 3 = 2.14 / PORTION
//         if (discountedNum !== null && multiplier > 0) {
//           const unitPrice = discountedNum / multiplier;
//           card.querySelector('.rc-flat-card__per').textContent = sym + unitPrice.toFixed(2) + ' / PORTION';
//         }
//       } else {
//         // One-time: qty=1, per unit = full price
//         const onetimeWholeNum = parsePrice(snap.onetime);
//         card.querySelector('.rc-flat-card__price').textContent = formatWhole(onetimeWholeNum, sym);
//         if (onetimeNum !== null) {
//           card.querySelector('.rc-flat-card__per').textContent = sym + onetimeNum.toFixed(2) + ' / PORTION';
//         }
//       }

//       syncBenefits(card);
//     }

//     // Restore original selection
//     if (origSubChecked && origPlanChecked) { subInput.click(); origPlanChecked.click(); }
//     else if (!origSubChecked && onetimeInput) onetimeInput.click();

//     /* ── MutationObserver: keep active card benefits live ── */
//     const benefitsEl = shadowQueryAll(shadow, 'rc-benefits')[0];
//     if (benefitsEl && benefitsEl.shadowRoot) {
//       new MutationObserver(function() {
//         const active = cards.find(function(c) { return c.card.classList.contains('active'); });
//         if (active) syncBenefits(active.card);
//       }).observe(benefitsEl.shadowRoot, { childList: true, subtree: true });
//     }
//   }

//   /* ─── Process widget ──────────────────────────────────────────── */
//   function processWidget(widget) {
//     if (widget._rcFlatProcessed) return;
//     widget._rcFlatProcessed = true;
//     waitForShadow(widget)
//       .then(function(shadow) { return buildUI(widget, shadow); })
//       .catch(function(err) { console.warn(err); });
//   }

//   /* ─── Init + DOM observer ─────────────────────────────────────── */
//   function init() {
//     document.querySelectorAll(WIDGET_TAG).forEach(processWidget);

//     new MutationObserver(function(mutations) {
//       mutations.forEach(function(mutation) {
//         mutation.addedNodes.forEach(function(node) {
//           if (node.nodeType !== Node.ELEMENT_NODE) return;
//           if (node.matches && node.matches(WIDGET_TAG)) processWidget(node);
//           if (node.querySelectorAll) node.querySelectorAll(WIDGET_TAG).forEach(processWidget);
//         });
//       });
//     }).observe(document.body, { childList: true, subtree: true });
//   }

//   document.readyState === 'loading'
//     ? document.addEventListener('DOMContentLoaded', init)
//     : init();
// })();

// (function () {
//   const WIDGET_TAG = 'recharge-subscription-widget';

//   const CONFIG = Object.assign({
//     defaultPortions : 30,
//     portionLabel    : 'PORTION',
//     saveBadgePrefix : 'SAVE ',
//     orDividerText   : 'OR',
//     bannerLabels    : ['MOST POPULAR', 'BEST VALUE'],
//   }, window.rcFlatConfig || {});

//   /*Shadow DOM helpers */
//   function shadowQueryAll(root, selector) {
//     const results = [];
//     (function walk(r) {
//       r.querySelectorAll(selector).forEach(el => results.push(el));
//       r.querySelectorAll('*').forEach(el => { if (el.shadowRoot) walk(el.shadowRoot); });
//     })(root);
//     return results;
//   }

//   function getBenefitsHTML(shadow) {
//     const el = shadowQueryAll(shadow, 'rc-benefits')[0];
//     const list = el?.shadowRoot?.querySelector('.rc-benefits__list');
//     return list ? list.innerHTML : '';
//   }

//   function cleanText(el) {
//     if (!el) return '';
//     const clone = el.cloneNode(true);
//     clone.querySelectorAll('.visually-hidden, [aria-hidden="true"]').forEach(n => n.remove());
//     return clone.textContent.trim();
//   }

//   /* Price helpers */
//   function pause(ms) { return new Promise(r => setTimeout(r, ms)); }

//   function parsePrice(str) {
//     if (!str) return null;
//     const cleaned = str.replace(/[^0-9.,]/g, '').replace(',', '.');
//     return parseFloat(cleaned) || null;
//   }

//   function formatWhole(num, symbol) {
//     if (num === null || num === undefined) return '';
//     return (symbol || '€') + Math.round(num);
//   }

//   function currencySymbol(str) {
//     const m = str && str.match(/[€$£]/);
//     return m ? m[0] : '€';
//   }

//   /* Read plan multiplier from DOM */
//   function detectMultiplier(label) {
//     const intervalEl = label.querySelector('[part~="rc-plans-button__interval"]');
//     if (!intervalEl) return 1;
//     const deliveryText = Array.from(intervalEl.childNodes)
//       .filter(n => n.nodeType === Node.TEXT_NODE)
//       .map(n => n.textContent.trim()).join(' ');
//     const deliveryDays = parseInt((deliveryText.match(/(\d+)/) || [])[1], 10) || null;
//     const billingEl    = intervalEl.querySelector('[part~="rc-plans-button__discount"]');
//     const billingDays  = parseInt(((billingEl && billingEl.textContent || '').match(/(\d+)/) || [])[1], 10) || null;
//     if (deliveryDays && billingDays && deliveryDays > 0) return Math.round(billingDays / deliveryDays) || 1;
//     return 1;
//   }

//   /* Read label texts from original widget */
//   function readPlanTitle(label) {
//     const intervalEl = label.querySelector('[part~="rc-plans-button__interval"]');
//     if (!intervalEl) return cleanText(label.querySelector('[part~="rc-plans-button"]')) || '';
//     const topText    = Array.from(intervalEl.childNodes)
//       .filter(n => n.nodeType === Node.TEXT_NODE)
//       .map(n => n.textContent.trim()).filter(Boolean).join(' ');
//     const billingEl  = intervalEl.querySelector('[part~="rc-plans-button__discount"]');
//     const billingText = billingEl ? billingEl.textContent.trim() : '';
//     return billingText ? topText + ' · ' + billingText : topText;
//   }

//   function readOnetimeLabel(shadow) {
//     const onetimeInput = shadow.querySelector('input[name="purchaseOption"][value="onetime"]');
//     if (onetimeInput) {
//       const parent = onetimeInput.closest('[part~="rc-purchase-option__selector"]');
//       if (parent) {
//         const clone = parent.cloneNode(true);
//         clone.querySelectorAll('input, rc-radio-icon').forEach(n => n.remove());
//         const text = clone.textContent.trim();
//         if (text) return text;
//       }
//     }
//     return '';
//   }

//   /* Capture prices */
//   function captureSnapshot(shadow) {
//     return {
//       discounted : cleanText(shadow.querySelector('[part~="rc-purchase-option__discounted-price"]')),
//       original   : cleanText(shadow.querySelector('[part~="rc-purchase-option__original-price"]')),
//       onetime    : cleanText(shadow.querySelector('[part~="rc-purchase-option__price"]')),
//     };
//   }

//   /* Wait for shadow DOM */
//   function waitForShadow(widget, timeout) {
//     timeout = timeout || 8000;
//     return new Promise(function(resolve, reject) {
//       var start = Date.now();
//       function check() {
//         var shadow = widget.shadowRoot;
//         if (shadow && shadow.querySelector('input[name="purchaseOption"]')) resolve(shadow);
//         else if (Date.now() - start > timeout) reject(new Error('[rc-flat] Shadow DOM timeout'));
//         else requestAnimationFrame(check);
//       }
//       check();
//     });
//   }

//   /* Build UI */
//   async function buildUI(widget, shadow) {
//     if (widget.previousElementSibling && widget.previousElementSibling.classList.contains('rc-flat-ui')) return;
//     widget.style.display = 'none';

//     // Portions: data-attr on widget > CONFIG default
//     const portions = parseInt(widget.getAttribute('data-portions'), 10) || CONFIG.defaultPortions;

//     const qtyInput = document.querySelector('input[name="quantity"]');
//     function setQty(val) {
//       if (!qtyInput) return;
//       qtyInput.value = val;
//       qtyInput.dispatchEvent(new Event('input',  { bubbles: true }));
//       qtyInput.dispatchEvent(new Event('change', { bubbles: true }));
//     }

//     const subInput     = shadow.querySelector('input[name="purchaseOption"][value="subscription"]');
//     const onetimeInput = shadow.querySelector('input[name="purchaseOption"][value="onetime"]');
//     const planLabels   = shadowQueryAll(shadow, 'label[part="rc-plans-radio-button"]');
//     const onetimeLabel = readOnetimeLabel(shadow);

//     const wrap = document.createElement('div');
//     wrap.className = 'rc-flat-ui';
//     const cards = [];

//     function setActive(card) {
//       cards.forEach(function(c) { c.card.classList.remove('active'); });
//       card.classList.add('active');
//     }
//     function syncBenefits(card) {
//       card.querySelector('.rc-flat-card__benefits').innerHTML = getBenefitsHTML(shadow);
//     }

//     /* Plan cards */
//     planLabels.forEach(function(label, i) {
//       const radio    = label.querySelector('input[type="radio"]');
//       if (!radio) return;
//       const isActive = !!(radio.checked && subInput && subInput.checked);
//       const banner   = (CONFIG.bannerLabels && CONFIG.bannerLabels[i]) || '';

//       const card = document.createElement('button');
//       card.type = 'button';
//       card.className = 'rc-flat-card' + (isActive ? ' active' : '');
//       card.innerHTML =
//         (banner ? '<div class="rc-flat-card__banner">' + banner + '</div>' : '') +
//         '<div class="rc-flat-card__body">' +
//           '<div class="rc-flat-card__main">' +
//             '<div class="rc-flat-card__dot"></div>' +
//             '<div class="rc-flat-card__label-group">' +
//               '<span class="rc-flat-card__title">' + readPlanTitle(label) + '</span>' +
//               '<span class="rc-flat-card__per"></span>' +
//             '</div>' +
//             '<div class="rc-flat-card__right">' +
//               '<span class="rc-flat-card__save" style="display:none"></span>' +
//               '<span class="rc-flat-card__original"></span>' +
//               '<span class="rc-flat-card__price"></span>' +
//             '</div>' +
//           '</div>' +
//           '<div class="rc-flat-card__benefits"></div>' +
//         '</div>';

//       card.addEventListener('click', function() {
//         if (subInput && !subInput.checked) subInput.click();
//         radio.click();
//         setActive(card);
//         setQty(detectMultiplier(label));
//         setTimeout(function() { syncBenefits(card); }, 60);
//       });

//       wrap.appendChild(card);
//       cards.push({ card: card, radio: radio, type: 'plan', label: label });
//     });

//     /* OR divider */
//     const divider = document.createElement('div');
//     divider.className = 'rc-flat-divider';
//     divider.textContent = CONFIG.orDividerText;
//     wrap.appendChild(divider);

//     /* One-time card */
//     if (onetimeInput) {
//       const card = document.createElement('button');
//       card.type = 'button';
//       card.className = 'rc-flat-card onetime' + (onetimeInput.checked ? ' active' : '');
//       card.innerHTML =
//         '<div class="rc-flat-card__body">' +
//           '<div class="rc-flat-card__main">' +
//             '<div class="rc-flat-card__dot"></div>' +
//             '<div class="rc-flat-card__label-group">' +
//               '<span class="rc-flat-card__title">' + onetimeLabel + '</span>' +
//               '<span class="rc-flat-card__per"></span>' +
//             '</div>' +
//             '<div class="rc-flat-card__right">' +
//               '<span class="rc-flat-card__price"></span>' +
//             '</div>' +
//           '</div>' +
//           '<div class="rc-flat-card__benefits"></div>' +
//         '</div>';

//       card.addEventListener('click', function() {
//         onetimeInput.click();
//         setActive(card);
//         setQty(1);
//         setTimeout(function() { syncBenefits(card); }, 60);
//       });
//       wrap.appendChild(card);
//       cards.push({ card: card, radio: onetimeInput, type: 'onetime', label: null });
//     }

//     widget.parentNode.insertBefore(wrap, widget);

//     /* Silent cycle: snapshot prices per plan */
//     const origSubChecked  = subInput && subInput.checked;
//     const origPlanChecked = planLabels
//       .map(function(l) { return l.querySelector('input[type="radio"]'); })
//       .find(function(r) { return r && r.checked; });

//     let onetimeNum = null, sym = '€';
//     if (onetimeInput) {
//       onetimeInput.click();
//       await pause(120);
//       const snap = captureSnapshot(shadow);
//       onetimeNum = parsePrice(snap.onetime);
//       if (snap.onetime) sym = currencySymbol(snap.onetime);
//     }

//     for (var i = 0; i < cards.length; i++) {
//       var entry = cards[i];
//       if (entry.type === 'plan') {
//         if (subInput && !subInput.checked) subInput.click();
//         entry.radio.click();
//       } else {
//         onetimeInput.click();
//       }
//       await pause(120);

//       var snap       = captureSnapshot(shadow);
//       var multiplier = qtyInput ? (parseInt(qtyInput.value, 10) || 1) : 1;

//       if (entry.type === 'plan') {
//         var disc   = parsePrice(snap.discounted);
//         var full   = disc !== null ? disc * multiplier : null;
//         var cross  = onetimeNum !== null ? onetimeNum * multiplier : parsePrice(snap.original);

//         entry.card.querySelector('.rc-flat-card__original').textContent = formatWhole(cross, sym);
//         entry.card.querySelector('.rc-flat-card__price').textContent    = formatWhole(full, sym);

//         if (onetimeNum !== null && disc !== null) {
//           var saveEl = entry.card.querySelector('.rc-flat-card__save');
//           saveEl.textContent   = CONFIG.saveBadgePrefix +" "+ formatWhole((onetimeNum - disc) * multiplier, sym);
//           saveEl.style.display = '';
//         }
//         if (disc !== null && portions > 0) {
//           entry.card.querySelector('.rc-flat-card__per').textContent =
//             sym + (disc / portions).toFixed(2) + ' / ' + CONFIG.portionLabel;
//         }
//       } else {
//         var otNum = parsePrice(snap.onetime);
//         entry.card.querySelector('.rc-flat-card__price').textContent = formatWhole(otNum, sym);
//         if (onetimeNum !== null && portions > 0) {
//           entry.card.querySelector('.rc-flat-card__per').textContent =
//             sym + (onetimeNum / portions).toFixed(2) + ' / ' + CONFIG.portionLabel;
//         }
//       }

//       syncBenefits(entry.card);
//     }

//     if (origSubChecked && origPlanChecked) { subInput.click(); origPlanChecked.click(); }
//     else if (!origSubChecked && onetimeInput) onetimeInput.click();

//     var benefitsEl = shadowQueryAll(shadow, 'rc-benefits')[0];
//     if (benefitsEl && benefitsEl.shadowRoot) {
//       new MutationObserver(function() {
//         var active = cards.find(function(c) { return c.card.classList.contains('active'); });
//         if (active) syncBenefits(active.card);
//       }).observe(benefitsEl.shadowRoot, { childList: true, subtree: true });
//     }
//   }

//   /* Process + observe */
//   function processWidget(widget) {
//     if (widget._rcFlatProcessed) return;
//     widget._rcFlatProcessed = true;
//     waitForShadow(widget)
//       .then(function(shadow) { return buildUI(widget, shadow); })
//       .catch(function(err) { console.warn(err); });
//   }

//   function init() {
//     document.querySelectorAll(WIDGET_TAG).forEach(processWidget);
//     new MutationObserver(function(mutations) {
//       mutations.forEach(function(mutation) {
//         mutation.addedNodes.forEach(function(node) {
//           if (node.nodeType !== Node.ELEMENT_NODE) return;
//           if (node.matches && node.matches(WIDGET_TAG)) processWidget(node);
//           if (node.querySelectorAll) node.querySelectorAll(WIDGET_TAG).forEach(processWidget);
//         });
//       });
//     }).observe(document.body, { childList: true, subtree: true });
//   }

//   document.readyState === 'loading'
//     ? document.addEventListener('DOMContentLoaded', init)
//     : init();
// })();

// Latest RC clone
(function () {
  const WIDGET_TAG = 'recharge-subscription-widget';

  const CONFIG = Object.assign({
    defaultPortions : 30,
    portionLabel    : 'PORTION',
    saveBadgePrefix : 'SAVE ',
    orDividerText   : 'OR',
    bannerLabels    : ['MOST POPULAR', 'BEST VALUE'],
  }, window.rcFlatConfig || {});

  /*Shadow DOM helpers */
  function shadowQueryAll(root, selector) {
    const results = [];
    (function walk(r) {
      r.querySelectorAll(selector).forEach(el => results.push(el));
      r.querySelectorAll('*').forEach(el => { if (el.shadowRoot) walk(el.shadowRoot); });
    })(root);
    return results;
  }

  function getBenefitsHTML(shadow) {
    const el = shadowQueryAll(shadow, 'rc-benefits')[0];
    const list = el?.shadowRoot?.querySelector('.rc-benefits__list');
    return list ? list.innerHTML : '';
  }

  function cleanText(el) {
    if (!el) return '';
    const clone = el.cloneNode(true);
    clone.querySelectorAll('.visually-hidden, [aria-hidden="true"]').forEach(n => n.remove());
    return clone.textContent.trim();
  }

  /* Price helpers */
  function pause(ms) { return new Promise(r => setTimeout(r, ms)); }

  function parsePrice(str) {
    if (!str) return null;
    const cleaned = str.replace(/[^0-9.,]/g, '').replace(',', '.');
    return parseFloat(cleaned) || null;
  }

  function formatWhole(num, symbol) {
    if (num === null || num === undefined) return '';
    return (symbol || '') + ' ' + Math.round(num);
  }

  // Detect currency symbol from any price string in the shadow DOM
  // Supports symbols (€$£) and codes (USD, CHF, etc.)
  function detectCurrencySymbol(shadow) {
    const candidates = [
      shadow.querySelector('[part~="rc-purchase-option__discounted-price"]'),
      shadow.querySelector('[part~="rc-purchase-option__original-price"]'),
      shadow.querySelector('[part~="rc-purchase-option__price"]'),
    ];
    for (const el of candidates) {
      if (!el) continue;
      const text = cleanText(el);
      if (!text) continue;
      // Named symbol: €, $, £, ¥, ₹, etc.
      const symbolMatch = text.match(/^([^\d\s,.]+)/);
      if (symbolMatch) return symbolMatch[1];
      // Currency code suffix: "100.00 CHF", "CHF 100.00"
      const codeMatch = text.match(/([A-Z]{2,4})/);
      if (codeMatch) return codeMatch[1] + ' ';
    }
    return '';
  }

  /* Read plan multiplier from DOM */
  function detectMultiplier(label) {
    if (!label) return 1;
    const intervalEl = label.querySelector('[part~="rc-plans-button__interval"]');
    if (!intervalEl) return 1;
    const deliveryText = Array.from(intervalEl.childNodes)
      .filter(n => n.nodeType === Node.TEXT_NODE)
      .map(n => n.textContent.trim()).join(' ');
    const deliveryDays = parseInt((deliveryText.match(/(\d+)/) || [])[1], 10) || null;
    const billingEl    = intervalEl.querySelector('[part~="rc-plans-button__discount"]');
    const billingDays  = parseInt(((billingEl && billingEl.textContent || '').match(/(\d+)/) || [])[1], 10) || null;
    if (deliveryDays && billingDays && billingDays !== deliveryDays && deliveryDays > 0) return Math.round(billingDays / deliveryDays) || 1;
    return 1;
  }

  /* Read label texts from original widget */
  function readPlanTitle(label) {
    const intervalEl = label.querySelector('[part~="rc-plans-button__interval"]');
    if (!intervalEl) return cleanText(label.querySelector('[part~="rc-plans-button"]')) || '';
    const topText    = Array.from(intervalEl.childNodes)
      .filter(n => n.nodeType === Node.TEXT_NODE)
      .map(n => n.textContent.trim()).filter(Boolean).join(' ');
    const billingEl  = intervalEl.querySelector('[part~="rc-plans-button__discount"]');
    const billingText = billingEl ? billingEl.textContent.trim() : '';
    return billingText ? topText + ' · ' + billingText : topText;
  }

  function readOnetimeLabel(shadow) {
    const onetimeInput = shadow.querySelector('input[name="purchaseOption"][value="onetime"]');
    if (onetimeInput) {
      const parent = onetimeInput.closest('[part~="rc-purchase-option__selector"]');
      if (parent) {
        const clone = parent.cloneNode(true);
        clone.querySelectorAll('input, rc-radio-icon').forEach(n => n.remove());
        const text = clone.textContent.trim();
        if (text) return text;
      }
    }
    return '';
  }

  /* Capture prices */
  function captureSnapshot(shadow) {
    return {
      discounted : cleanText(shadow.querySelector('[part~="rc-purchase-option__discounted-price"]')),
      original   : cleanText(shadow.querySelector('[part~="rc-purchase-option__original-price"]')),
      onetime    : cleanText(shadow.querySelector('[part~="rc-purchase-option__price"]')),
    };
  }

  /* Wait for shadow DOM */
  function waitForShadow(widget, timeout) {
    timeout = timeout || 8000;
    return new Promise(function(resolve, reject) {
      var start = Date.now();
      function check() {
        var shadow = widget.shadowRoot;
        if (shadow && shadow.querySelector('input[name="purchaseOption"]')) resolve(shadow);
        else if (Date.now() - start > timeout) reject(new Error('[rc-flat] Shadow DOM timeout'));
        else requestAnimationFrame(check);
      }
      check();
    });
  }

  /* Build UI */
  async function buildUI(widget, shadow) {
    if (widget.previousElementSibling && widget.previousElementSibling.classList.contains('rc-flat-ui')) return;
    widget.style.display = 'none';

    const portions  = parseInt(widget.getAttribute('data-portions'), 10) || CONFIG.defaultPortions;

    const qtyInput = document.querySelector('input[name="quantity"]');
    function setQty(val) {
      if (!qtyInput) return;
      qtyInput.value = val;
      qtyInput.dispatchEvent(new Event('input',  { bubbles: true }));
      qtyInput.dispatchEvent(new Event('change', { bubbles: true }));
    }

    const subInput     = shadow.querySelector('input[name="purchaseOption"][value="subscription"]');
    const onetimeInput = shadow.querySelector('input[name="purchaseOption"][value="onetime"]');
    const planLabels   = shadowQueryAll(shadow, 'label[part="rc-plans-radio-button"]');
    const onetimeLabel = readOnetimeLabel(shadow);

    const wrap = document.createElement('div');
    wrap.className = 'rc-flat-ui';
    const cards = [];

    function setActive(card) {
      cards.forEach(function(c) { c.card.classList.remove('active'); });
      card.classList.add('active');
    }
    function syncBenefits(card) {
      card.querySelector('.rc-flat-card__benefits').innerHTML = getBenefitsHTML(shadow);
    }

    /* Plan cards */
    planLabels.forEach(function(label, i) {
      const radio    = label.querySelector('input[type="radio"]');
      if (!radio) return;
      const isActive = !!(radio.checked && subInput && subInput.checked);
      const banner   = (CONFIG.bannerLabels && CONFIG.bannerLabels[i]) || '';

      const card = document.createElement('button');
      card.type = 'button';
      card.className = 'rc-flat-card' + (isActive ? ' active' : '');
      card.innerHTML =
        (banner ? '<div class="rc-flat-card__banner">' + banner + '</div>' : '') +
        '<div class="rc-flat-card__body">' +
          '<div class="rc-flat-card__main">' +
            '<div class="rc-flat-card__dot"></div>' +
            '<div class="rc-flat-card__label-group">' +
              '<span class="rc-flat-card__title">' + readPlanTitle(label) + '</span>' +
              '<span class="rc-flat-card__per"></span>' +
            '</div>' +
            '<div class="rc-flat-card__right">' +
              '<span class="rc-flat-card__save" style="display:none"></span>' +
              '<span class="rc-flat-card__original"></span>' +
              '<span class="rc-flat-card__price"></span>' +
            '</div>' +
          '</div>' +
          '<div class="rc-flat-card__benefits"></div>' +
        '</div>';

      card.addEventListener('click', function() {
        if (subInput && !subInput.checked) subInput.click();
        radio.click();
        setActive(card);
        // setQty(detectMultiplier(label));
        setTimeout(function() { syncBenefits(card); }, 60);
      });

      wrap.appendChild(card);
      cards.push({ card: card, radio: radio, type: 'plan', label: label });
    });

    /* OR divider */
    const divider = document.createElement('div');
    divider.className = 'rc-flat-divider';
    divider.textContent = CONFIG.orDividerText;
    wrap.appendChild(divider);

    /* One-time card */
    if (onetimeInput) {
      const card = document.createElement('button');
      card.type = 'button';
      card.className = 'rc-flat-card onetime' + (onetimeInput.checked ? ' active' : '');
      card.innerHTML =
        '<div class="rc-flat-card__body">' +
          '<div class="rc-flat-card__main">' +
            '<div class="rc-flat-card__dot"></div>' +
            '<div class="rc-flat-card__label-group">' +
              '<span class="rc-flat-card__title">' + onetimeLabel + '</span>' +
              '<span class="rc-flat-card__per"></span>' +
            '</div>' +
            '<div class="rc-flat-card__right">' +
              '<span class="rc-flat-card__price"></span>' +
            '</div>' +
          '</div>' +
          '<div class="rc-flat-card__benefits"></div>' +
        '</div>';

      card.addEventListener('click', function() {
        onetimeInput.click();
        setActive(card);
        setQty(1);
        setTimeout(function() { syncBenefits(card); }, 60);
      });
      wrap.appendChild(card);
      cards.push({ card: card, radio: onetimeInput, type: 'onetime', label: null });
    }

    widget.parentNode.insertBefore(wrap, widget);

    /* Silent cycle: snapshot prices per plan */
    const origSubChecked  = subInput && subInput.checked;
    const origPlanChecked = planLabels
      .map(function(l) { return l.querySelector('input[type="radio"]'); })
      .find(function(r) { return r && r.checked; });

    let onetimeNum = null;
    if (onetimeInput) {
      onetimeInput.click();
      await pause(120);
      const snap = captureSnapshot(shadow);
      onetimeNum = parsePrice(snap.onetime);
    }

    for (var i = 0; i < cards.length; i++) {
      var entry = cards[i];
      if (entry.type === 'plan') {
        if (subInput && !subInput.checked) subInput.click();
        entry.radio.click();
      } else {
        onetimeInput.click();
      }
      await pause(120);

      // Detect currency fresh from shadow DOM on each iteration — correct for any currency
      var sym        = detectCurrencySymbol(shadow);
      var snap       = captureSnapshot(shadow);
      var qty        = qtyInput ? (parseInt(qtyInput.value, 10) || 1) : 1;
      var multiplier = entry.type === 'plan' ? detectMultiplier(entry.label) * qty : qty;

      if (entry.type === 'plan') {
        var disc   = parsePrice(snap.discounted);
        var full   = disc !== null ? disc * multiplier : null;
        var cross  = onetimeNum !== null ? onetimeNum * multiplier : parsePrice(snap.original);

        entry.card.querySelector('.rc-flat-card__original').textContent = formatWhole(cross, sym);
        entry.card.querySelector('.rc-flat-card__price').textContent    = formatWhole(full, sym);

        if (onetimeNum !== null && disc !== null) {
          var saveEl = entry.card.querySelector('.rc-flat-card__save');
          saveEl.textContent   = CONFIG.saveBadgePrefix + ' ' + formatWhole((onetimeNum - disc) * multiplier, sym);
          saveEl.style.display = '';
        }
        if (disc !== null && portions > 0) {
          entry.card.querySelector('.rc-flat-card__per').textContent =
            sym + ' ' + (disc / portions).toFixed(2) + ' / ' + CONFIG.portionLabel;
        }
      } else {
        var otNum = parsePrice(snap.onetime);
        entry.card.querySelector('.rc-flat-card__price').textContent = formatWhole(otNum, sym);
        if (onetimeNum !== null && portions > 0) {
          entry.card.querySelector('.rc-flat-card__per').textContent =
            sym + ' ' + (onetimeNum / portions).toFixed(2) + ' / ' + CONFIG.portionLabel;
        }
      }

      syncBenefits(entry.card);
    }

    if (origSubChecked && origPlanChecked) { subInput.click(); origPlanChecked.click(); }
    else if (!origSubChecked && onetimeInput) onetimeInput.click();

    var benefitsEl = shadowQueryAll(shadow, 'rc-benefits')[0];
    if (benefitsEl && benefitsEl.shadowRoot) {
      new MutationObserver(function() {
        var active = cards.find(function(c) { return c.card.classList.contains('active'); });
        if (active) syncBenefits(active.card);
      }).observe(benefitsEl.shadowRoot, { childList: true, subtree: true });
    }
  }

  /* Process + observe */
  function processWidget(widget) {
    if (widget._rcFlatProcessed) return;
    widget._rcFlatProcessed = true;
    waitForShadow(widget)
      .then(function(shadow) { return buildUI(widget, shadow); })
      .catch(function(err) { console.warn(err); });
  }

  function init() {
    document.querySelectorAll(WIDGET_TAG).forEach(processWidget);
    new MutationObserver(function(mutations) {
      mutations.forEach(function(mutation) {
        mutation.addedNodes.forEach(function(node) {
          if (node.nodeType !== Node.ELEMENT_NODE) return;
          if (node.matches && node.matches(WIDGET_TAG)) processWidget(node);
          if (node.querySelectorAll) node.querySelectorAll(WIDGET_TAG).forEach(processWidget);
        });
      });
    }).observe(document.body, { childList: true, subtree: true });
  }

  document.readyState === 'loading'
    ? document.addEventListener('DOMContentLoaded', init)
    : init();
})();